/* globals VXConfig */

import { createRoot } from 'react-dom/client';
import withSuspense from '../HigherOrderComponents/Utility/withSuspense.jsx';
import { addPreventScrolling, removePreventScrolling } from '../../utils/CommonUtils';
import { lazy } from 'react';

const ModalBoxBounceEmailVerification = lazy(() => import('./ModalBoxBounceEmailVerification'));
const ModalBoxConversionChat = lazy(() => import('./ModalBoxConversionChat'));
const ModalBoxVip30 = lazy(() => import('./ModalBoxVip30'));
const ModalBoxBlackFriday2020 = lazy(() => import('./ModalBoxBlackFriday2020'));
const ModalBoxAvs = lazy(() => import('./ModalBoxAvs'));
const ModalBoxTagRewardBasic = lazy(() => import('./ModalBoxTagRewardBasic'));
const ModalBoxTagRewardAdvanced = lazy(() => import('./ModalBoxTagRewardAdvanced'));
const ModalBoxTagRewardPro = lazy(() => import('./ModalBoxTagRewardPro'));
const ModalBoxActorGiftCalendar = lazy(() => import('./ModalBoxActorGiftCalendar'));
const ModalBoxNotEnoughMoney = lazy(() => import('./ModalBoxNotEnoughMoney'));
const ModalBoxVideoWithPlayer = lazy(() => import('./ModalBoxVideoWithPlayer'));
const ModalBoxLexyKalender2023 = lazy(() => import('./ModalBoxLexyKalender2023'));
const ModalBoxFeedSignup = lazy(() => import('./ModalBoxFeedSignup'));
const ModalBoxSexoleLogin = lazy(() => import('./ModalBoxSexoleLogin'));
const ModalBoxEsAVS = lazy(() => import('./ModalBoxEsAVS'));
const ModalboxOnboarding = lazy(() => import('./ModalBoxOnboarding'));
const ModalBoxSpecialTopUp = lazy(() => import('./ModalBoxSpecialTopUp.jsx'));
const ModalBoxModelConversion = lazy(() => import('./ModalBoxModelConversion.jsx'));
const ModalBoxFiveDaysBonus = lazy(() => import('./ModalBoxFiveDaysBonus.jsx'));
const ModalBoxVXCoinInfo = lazy(() => import('./ModalBoxVXCoinInfo'));
const ModalboxOnboardingChoose = lazy(() => import('./ModalBoxOnboardingChoose'));
const ModalBoxWrapperExample = lazy(() => import('./ModalBoxWrapper/ModalBoxWrapperExample'));
const ModalBoxContestLike = lazy(() => import('./ModalBoxContestLike'));
const ModalBoxPlaylistDelete = lazy(() => import('./Playlist/ModalBoxPlaylistDelete'));
const ModalBoxPlaylistCancelChanges = lazy(() => import('./Playlist/ModalBoxPlaylistCancelChanges'));
const SurveyFeedback = lazy(() => import('../Survey/SurveyFeedback.jsx'));
const ModalBoxRewardCongrats = lazy(() => import('./RewardCongrats/ModalBoxRewardCongrats.jsx'));
const ModalBoxInboxFull = lazy(() => import('./ModalBoxInboxFull.jsx'));
const ModalBoxIntroduction = lazy(() => import('./ModalBoxIntroduction.jsx'));
const ModalBoxCards = lazy(() => import('./Cards/ModalBoxCards.jsx'));
const ModalBoxTicketBought = lazy(() => import('./../Profile/ProfileLiveShow/TicketBoughtModalBox.jsx'));
const ModalBoxUberWelcome = lazy(() => import('./ModalBoxUberWelcome/ModalBoxUberWelcome.jsx'));

const ModalBoxEnum = {
	CONVERSION_CHAT: 'conversion-chat',
	VIP_30: 'vip30',
	BLACK_FRIDAY_2020: 'black-friday-2020',
	AVS: 'avs',
	TAG_REWARD_BASIC: 'tag-reward-basic',
	TAG_REWARD_PRO: 'tag-reward-pro',
	TAG_REWARD_ADVANCED: 'tag-reward-advanced',
	ACTOR_GIFT_CALENDAR: 'actor-gift-calendar',
	NOT_ENOUGH_MONEY: 'not-enough-money',
	LEXYKALENDER2022: 'lexykalender2022',
	LEXYKALENDER2023: 'lexykalender2023',
	VIDEOS_WITH_PLAYER: 'video-with-player',
	FEED_SIGNUP: 'feed-signup',
	SEXOLE_LOGIN: 'sexole-login',
	ES_AVS: 'es-avs',
	SPECIAL_TOP_UP: 'specialTopUp',
	VXMODELSITES_CONVERSION: 'vxmodelsites-conversion',
	FIVE_DAYS_BONUS: 'five-days-bonus',
	ONBOARDING: 'onboarding',
	ONBOARDING_CHOOSE: 'onboarding-choose',
	FIFTEEN_MINUTES_PREVIEW: 'fifteen-minutes-preview',
	VXCOIN_INFO: 'vxcoin-info',
	MODAL_WRAPPER_EXAMPLE: 'modal-wrapper-example',
	CONTEST_LIKE: 'contest-like',
	SURVEY: 'survey',
	PLAYLIST_DELETE: 'playlist-delete',
	PLAYLIST_CANCEL_CHANGES: 'playlist-cancel-changes',
	INBOX_FULL: 'inbox-full',
	INTRODUCTION: 'introduction',
	EMAIL_BOUNCE_VERIFICATION: 'email-bounce-verification',
	CARDS: 'cards',
	REWARD_CONGRATS: 'reward-congrats',
	TICKET_BOUGHT: 'ticket-bought',
	UBER_WELCOME: 'uber-welcome',
};

/**
 * Get instance of the ModalBox
 * @param id
 * @param props
 * @returns {*}
 */
const getModalBoxById = (id, props = {}) => {
	switch (id) {
		case ModalBoxEnum.CONVERSION_CHAT:
			return <ModalBoxConversionChat {...props} />;
		case ModalBoxEnum.VIP_30:
			return <ModalBoxVip30 {...props} />;
		case ModalBoxEnum.BLACK_FRIDAY_2020:
			return <ModalBoxBlackFriday2020 />;
		case ModalBoxEnum.AVS:
			return <ModalBoxAvs {...props} />;
		case ModalBoxEnum.TAG_REWARD_BASIC:
			return <ModalBoxTagRewardBasic {...props} isMobile={VXConfig.isVXMobilePlatform} />;
		case ModalBoxEnum.TAG_REWARD_ADVANCED:
			return <ModalBoxTagRewardAdvanced {...props} isMobile={VXConfig.isVXMobilePlatform} />;
		case ModalBoxEnum.TAG_REWARD_PRO:
			return <ModalBoxTagRewardPro {...props} isMobile={VXConfig.isVXMobilePlatform} />;
		case ModalBoxEnum.ACTOR_GIFT_CALENDAR:
			return <ModalBoxActorGiftCalendar {...props} isMobile={VXConfig.isVXMobilePlatform} />;
		case ModalBoxEnum.NOT_ENOUGH_MONEY:
			return <ModalBoxNotEnoughMoney {...props} />;
		case ModalBoxEnum.LEXYKALENDER2022:
		case ModalBoxEnum.LEXYKALENDER2023:
			return <ModalBoxLexyKalender2023 {...props} />;
		case ModalBoxEnum.VIDEOS_WITH_PLAYER:
			return <ModalBoxVideoWithPlayer {...props} />;
		case ModalBoxEnum.FEED_SIGNUP:
			return <ModalBoxFeedSignup {...props} />;
		case ModalBoxEnum.SEXOLE_LOGIN:
			return <ModalBoxSexoleLogin {...props} />;
		case ModalBoxEnum.ES_AVS:
			return <ModalBoxEsAVS {...props} />;
		case ModalBoxEnum.ONBOARDING:
			return <ModalboxOnboarding {...props} />;
		case ModalBoxEnum.ONBOARDING_CHOOSE:
			return <ModalboxOnboardingChoose {...props} />;
		case ModalBoxEnum.SPECIAL_TOP_UP:
			return <ModalBoxSpecialTopUp {...props} id={id} />;
		case ModalBoxEnum.VXMODELSITES_CONVERSION:
			return <ModalBoxModelConversion {...props} id={id} />;
		case ModalBoxEnum.FIVE_DAYS_BONUS:
			return <ModalBoxFiveDaysBonus {...props} id={id} />;
		case ModalBoxEnum.VXCOIN_INFO:
			return <ModalBoxVXCoinInfo {...props} id={id} />;
		case ModalBoxEnum.MODAL_WRAPPER_EXAMPLE:
			return <ModalBoxWrapperExample {...props} id={id} />;
		case ModalBoxEnum.CONTEST_LIKE:
			return <ModalBoxContestLike {...props} id={id} />;
		case ModalBoxEnum.PLAYLIST_DELETE:
			return <ModalBoxPlaylistDelete {...props} id={id} />;
		case ModalBoxEnum.SURVEY:
			return <SurveyFeedback {...props} id={id} />;
		case ModalBoxEnum.PLAYLIST_CANCEL_CHANGES:
			return <ModalBoxPlaylistCancelChanges {...props} id={id} />;
		case ModalBoxEnum.INBOX_FULL:
			return <ModalBoxInboxFull {...props} id={id} />;
		case ModalBoxEnum.INTRODUCTION:
			return <ModalBoxIntroduction {...props} id={id} />;
		case ModalBoxEnum.EMAIL_BOUNCE_VERIFICATION:
			return <ModalBoxBounceEmailVerification {...props} id={id} />;
		case ModalBoxEnum.CARDS:
			return <ModalBoxCards {...props} id={id} />;
		case ModalBoxEnum.REWARD_CONGRATS:
			return <ModalBoxRewardCongrats {...props} id={id} />;
		case ModalBoxEnum.TICKET_BOUGHT:
			return <ModalBoxTicketBought {...props} id={id} />;
		case ModalBoxEnum.UBER_WELCOME:
			return <ModalBoxUberWelcome {...props} id={id} />;
		default:
	}
};

/**
 * Render ModalBox in DOM
 * @param id
 * @param props
 * @returns {closeFn}
 */
const openModalBox = (id, props = {}, onClose) => {
	if (document.getElementById(id)) {
		return null;
	}

	const containerId = 'modalbox-factory-container';
	let container = document.getElementById(containerId);

	if (container) {
		container.parentNode.removeChild(container);
	}

	// init DOM container
	container = document.createElement('div');
	container.id = containerId;

	const root = createRoot(container);

	if (props.overCookie) {
		container.classList.add('over-cookie');
	}
	if (props.preventScrolling) {
		addPreventScrolling();
	}
	document.body.appendChild(container);

	// default props
	const closeFn = () => {
		if (typeof onClose === 'function') {
			onClose();
		}
		if (document.getElementById(containerId)) {
			if (props.overCookie) {
				container.classList.remove('over-cookie');
			}
			if (props.preventScrolling) {
				removePreventScrolling();
			}
			root.unmount();
			document.getElementById(containerId)?.parentNode.removeChild(document.getElementById(containerId));
		}
	};
	props.onClose = closeFn;

	const modalBox = getModalBoxById(id, props);

	root.render(withSuspense(modalBox));

	return closeFn;
};

function openVip30Modal() {
	openModalBox(ModalBoxEnum.VIP_30);
}

function openActorGiftCalendarModal(props) {
	openModalBox(ModalBoxEnum.ACTOR_GIFT_CALENDAR, props);
}

function openNotEnoughMoneyModal(props) {
	openModalBox(ModalBoxEnum.NOT_ENOUGH_MONEY, props);
}

export { openModalBox, ModalBoxEnum, openVip30Modal, openActorGiftCalendarModal, openNotEnoughMoneyModal };
